<h3>Thuisverzorger</h3>
<form [formGroup]="upsertThuisverzorgerForm"
  (ngSubmit)="onOkClicked()">
  <mat-form-field>
    <mat-label>Voornaam</mat-label>
    <input matInput
      formControlName="voornaam"
      type="text"
      placeholder="Jan"
      required>
    @if (voornaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Achternaam</mat-label>
    <input matInput
      formControlName="achternaam"
      type="text"
      placeholder="Janssen"
      required>
    @if (achternaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Personeelsnummer</mat-label>
    <input matInput
      formControlName="personeelsnummer"
      type="text"
      placeholder="P0234"
      required>
    @if (personeelsnummer.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput
      formControlName="email"
      type="email"
      placeholder="jan@janssen.be"
      required>
    @if (email.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
    @if (email.hasError('email')) {
      <mat-error>Geen geldig email adres</mat-error>
    }
  </mat-form-field>
  <mat-expansion-panel class="diensten-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Diensten
      </mat-panel-title>
      <mat-panel-description>
        {{getSelectedDienstNames()}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    @for (thuisverzorgerDienst of getThuisVerzorgerDiensten(); track thuisverzorgerDienst) {
      <mat-list-item [lines]="4">
        <div matListItemTitle class="dienst-header">{{getDienst(thuisverzorgerDienst.getId()).getLabel()}}
          <button class="enable-pointer-events"
            mat-icon-button
            type="button"
            (click)="$event.stopPropagation(); onDienstDeleteClick(thuisverzorgerDienst)">
            <mat-icon>delete_outline</mat-icon>
          </button></div>
          <mat-form-field matListItemTitle class="dienst-zones-field enable-pointer-events">
            <mat-label>Zones</mat-label>
            <mat-select multiple (valueChange)="onZoneIdValueChanged(thuisverzorgerDienst, $event)" [value]="thuisverzorgerDienst.getZoneIds()">
              @for (zoneId of getDienst(thuisverzorgerDienst.getId()).getAvailableZoneIds(); track zoneId) {
                <mat-option [value]="zoneId">{{zoneId | zahZone:zones}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-list-item>
      }
      @if (upsertThuisverzorgerForm.controls.diensten.value.length === 0) {
        <mat-list-item
          class="no-list-item-highlight"
          disableRipple>
          <div matListItemTitle>Geen diensten ingegeven</div>
        </mat-list-item>
      }
      <mat-action-row>
        <button mat-button color="primary" type="button" (click)="onAddDienstClick()" [disabled]="getAvailableDiensten().length === 0">Voeg dienst toe</button>
      </mat-action-row>
    </mat-expansion-panel>
    <div class="actions">
      <button mat-button
        color="primary"
        type="button"
        (click)="onCancelClicked()">
        Annuleer
      </button>
      <button mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!upsertThuisverzorgerForm.valid">
        {{okLabel}}
      </button>
    </div>
  </form>
